import { zakresStrony } from "../../lib/developer.js";
import { IconChevronLewo, IconChevronPrawo } from "../icons/index.js";
import { Button } from "../ui/Button.js";

/**
 * PG-1..PG-3: paginacja pod tabela, w tej samej karcie. Zakres po lewej ("1-25 z 312" w --text-muted), po prawej
 * "Poprzednia" i "Nastepna" (Secondary, z chevronami). Pierwsza i ostatnia strona wylaczaja odpowiedni przycisk (powod
 * oczywisty, bez dymka). Przy jednej stronie komponent nie istnieje (PG-3): zakres "Strona 1 z 1" jest zabroniony.
 *
 * Podczas pobierania strony paginacja nie znika, tylko sie blokuje (S-7), a zakres opisuje dane NA EKRANIE (z odpowiedzi
 * serwera), nie to, o co wlasnie poprosilismy.
 */

export function Paginacja({
  offset,
  limit,
  razem,
  naStronie,
  zajeta,
  onZmiana,
}: {
  offset: number;
  limit: number;
  razem: number;
  /** Ile wierszy faktycznie jest na ekranie. */
  naStronie: number;
  /** Trwa pobieranie nowej strony. */
  zajeta: boolean;
  onZmiana: (nowyOffset: number) => void;
}): React.JSX.Element | null {
  if (razem <= limit) return null;
  const poprzednia = offset > 0;
  const nastepna = offset + limit < razem;

  return (
    <nav className="paginacja" aria-label="Strony wyników">
      <span className="paginacja__zakres" aria-live="polite">
        {zakresStrony(offset, naStronie, razem)}
      </span>
      <div className="paginacja__akcje">
        <Button wylaczony={!poprzednia || zajeta} onClick={() => onZmiana(Math.max(0, offset - limit))}>
          <IconChevronLewo size={18} />
          Poprzednia
        </Button>
        <Button wylaczony={!nastepna || zajeta} onClick={() => onZmiana(offset + limit)}>
          Następna
          <IconChevronPrawo size={18} />
        </Button>
      </div>
    </nav>
  );
}
